import Textarea from './Textarea';

export default Textarea;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Textarea/index.js